import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '@store/user';
import ImgCrop from 'antd-img-crop';
import { Avatar, Upload } from 'antd';
import { classNames, isNumber } from '@src/utils';
// import { RcCustomRequestOptions } from 'antd/lib/upload/interface'
import 'antd/es/slider/style';
import './user-avatar.scss';
var prefixCls = 'user-avatar';
var UserAvatar = function (props) {
    var dispatch = useDispatch();
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    var style = useMemo(function () {
        var style = {};
        if (isNumber(props.size)) {
            style.width = props.size + "px";
            style.height = props.size + "px";
        }
        return style;
    }, [props.size]);
    var handleOnChange = function (uploadInfo) {
        var file = uploadInfo.file;
        if (file.status === 'done' && file.response.status === true) {
            dispatch(actions.updateAvatar({
                url: file.response.result,
                userId: props.userId,
            }));
        }
    };
    // const handleCustomRequest = (option: RcCustomRequestOptions) => {
    //   console.log('handleCustomRequest')
    //   console.log(option)
    //   return void 0
    // }
    return (React.createElement("div", { className: className, style: style },
        React.createElement(Avatar, { size: props.size, src: props.src }),
        React.createElement("div", { className: prefixCls + "_hover" },
            React.createElement(ImgCrop, { rotate: true, grid: true, shape: "round", modalTitle: "\u66F4\u6362\u5934\u50CF", modalOk: "\u786E\u8BA4", modalCancel: "\u53D6\u6D88" },
                React.createElement(Upload, { accept: "image/png, image/jpeg, image/jpg", action: __PERSONAL_API__ + "/user/avatar", headers: { 'jwt-token': "" + sessionStorage.getItem('token') }, withCredentials: true, showUploadList: false, data: function (file) {
                        return new Promise(function (resolve) {
                            var reader = new FileReader();
                            reader.onload = function () {
                                return resolve({
                                    userAvatarFile: reader.result,
                                });
                            };
                            reader.readAsDataURL(file);
                        });
                    }, onChange: handleOnChange },
                    React.createElement("span", { className: prefixCls + "_hover__tips" }, "\u66F4\u65B0\u5934\u50CF"))))));
};
export default React.memo(UserAvatar);
